import React from 'react'
import { getElementDisplayName } from '../../utils/getElementDisplayName'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { Input } from 'alurkerja-ui'

type EditDefaultInputProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditDefaultInput(props: EditDefaultInputProps) {
  const { index, element, currentElementState, setCurrentElementState } = props

  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{stringToTitleCase(getElementDisplayName(element))}</span>
      <Input
        className="w-full"
        type="text"
        size="sm"
        rounded="lg"
        value={currentElementState[element]}
        onChange={(e) => {
          setCurrentElementState((prevState: any) => {
            return {
              ...prevState,
              [element]: e.target.value,
            }
          })
        }}
      />
    </div>
  )
}
